module.exports = __webpack_public_path__ + "img/Pot1.04a9c594.svg";